import { cva } from 'class-variance-authority';

// table variants are large, default and small
export const TABLE_HEADER_VARIANTS = cva('[&_tr]:!bg-neutral-3', {
  variants: {
    size: {
      default: 'h-14',
      sm: 'h-12',
      md: 'h-14',
      lg: 'h-16',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});
